import { markRaw, shallowReactive, type Component } from 'vue'
import ResultPagination from './ResultPagination.vue'
import SearchForm from './SearchForm.vue'
import TeaserSkeleton from './TeaserSkeleton.vue'

/** Built-in components a project can replace; teasers have their own registry (teasers/registry.ts). */
export const DEFAULT_COMPONENTS = { SearchForm, ResultPagination, TeaserSkeleton } satisfies Record<string, Component>

export type ComponentName = keyof typeof DEFAULT_COMPONENTS

export type ComponentMap = Partial<Record<ComponentName, Component>>

// reactive, so a registration after <agent-search-results> mounted still re-renders it
const registry = shallowReactive<ComponentMap>({})

/** Replaces a built-in component for all instances. */
export function registerComponent(name: ComponentName, component: Component): void {
    registry[name] = markRaw(component)
}

export function unregisterComponent(name: ComponentName): void {
    delete registry[name]
}

/** Local map first, then the registry, then the built-in component. */
export function componentFor(name: ComponentName, local?: ComponentMap): Component {
    return local?.[name] ?? registry[name] ?? DEFAULT_COMPONENTS[name]
}
